export const supportedLanguages = ["de", "en", "fr", "it"] as const;

export type SupportedLanguage = (typeof supportedLanguages)[number];

export const defaultLanguage: SupportedLanguage = "de";

export const isSupportedLanguage = (
	language: string
): language is SupportedLanguage =>
	supportedLanguages.includes(language as SupportedLanguage);

export const normalizeSupportedLanguage = (
	language: string | null | undefined
): SupportedLanguage => {
	const normalizedLanguage = language?.toLowerCase();

	if (!normalizedLanguage || !isSupportedLanguage(normalizedLanguage)) {
		return defaultLanguage;
	}

	return normalizedLanguage;
};
